import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  return (
    <div className="fade-in max-w-2xl mx-auto px-6 md:px-12 py-32 text-center" data-testid="order-success">
      <div className="w-16 h-16 mx-auto flex items-center justify-center" style={{ border: "1px solid var(--accent)" }}>
        <Check size={24} strokeWidth={1} className="text-[#B8895C]" />
      </div>
      <div className="font-micro text-[#B8895C] mt-8">Order Confirmed</div>
      <h1 className="font-serif text-[#EDE4D3] text-5xl mt-4">Welcome to the atelier.</h1>
      <p className="text-[#8A8680] mt-6 leading-relaxed">
        Your order <span className="text-[#D8D6D1]">#{id?.slice(0, 8)}</span> is with our studio. A consultant will call within 24 hours to confirm materials, dimensions and delivery.
      </p>
      <div className="flex gap-4 justify-center mt-12">
        <Link to="/" className="btn-ghost" data-testid="order-continue">Continue Browsing</Link>
        <a href="https://wa.me/917982295008" target="_blank" rel="noreferrer" className="btn-bronze" data-testid="order-whatsapp">WhatsApp Studio</a>
      </div>
    </div>
  );
}
